// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","grey":"#707070","light-grey":"#d4d4d4","black":"#000000","paginationList":"_23BhfWsF3XJhEHN-nczBXl","active":"_2A8ioFeyC4d_hizk8j9Bn0","navigationArrow":"_1qwkvj10jSPTqjnGEoeG1W","disabled":"_31vu85FE8s9-C-KNitzEus"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Pagination/NumeralPagination/NumeralPagination.css
// module id = 396
// module chunks = 0